import { render, staticRenderFns } from "./cRoleFlexOptions.vue?vue&type=template&id=00be099e&scoped=true"
import script from "./cRoleFlexOptions.vue?vue&type=script&lang=js"
export * from "./cRoleFlexOptions.vue?vue&type=script&lang=js"
import style0 from "./cRoleFlexOptions.vue?vue&type=style&index=0&id=00be099e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00be099e",
  null
  
)

export default component.exports